import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgTickBigFailed({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 174 88"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <g fill="none" fillRule="evenodd">
        <circle fill="#FDE4E2" cx={87} cy={44} r={44} />
        <path
          d="M87 56a6 6 0 110 12 6 6 0 010-12zm0-36a6 6 0 015.976 6.535l-.956 20.493h-.023a5 5 0 11-9.992-.407l-.977-20.035A6 6 0 0187 20z"
          fill="#D85145"
        />
        <path
          d="M23.961 21.264c-8.615 15.076-8.615 30.396 0 45.472a3.5 3.5 0 006.078-3.472c-7.385-12.924-7.385-25.604 0-38.528a3.5 3.5 0 00-6.078-3.472zM2.212 31.8C-.737 39.88-.737 48.06 2.21 56.192a3.5 3.5 0 106.582-2.384C6.404 47.219 6.404 40.733 8.788 34.2a3.5 3.5 0 00-6.576-2.4zM150.04 21.264c8.614 15.076 8.614 30.396 0 45.472a3.5 3.5 0 11-6.078-3.472c7.385-12.924 7.385-25.604 0-38.528a3.5 3.5 0 016.077-3.472zM171.789 31.8c2.949 8.08 2.949 16.26.003 24.392a3.5 3.5 0 11-6.582-2.384c2.387-6.589 2.387-13.075.003-19.608a3.5 3.5 0 116.576-2.4z"
          fill="#FDE4E2"
        />
      </g>
    </svg>
  );
}

SvgTickBigFailed.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgTickBigFailed.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgTickBigFailed svgRef={ref} {...props} />);
export default ForwardRef;
